import { KeyEvent, useKeyPress } from '@qfa/react-components';
import { useEffect } from 'react';

export const useSaveHotKey = (isSaveDisabled: boolean, onSave: () => void) => {
  const onSaveHotKey = (event: KeyEvent<HTMLElement>) => {
    event.preventDefault();
    !isSaveDisabled && onSave();
  };

  const onKeyDown = useKeyPress({ key: 's', ctrl: true, callback: onSaveHotKey });

  useEffect(() => {
    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, [onKeyDown]);
};
